<template>
  <div>
    <serviceList
      :bannerUrl="bannerUrl"
      :bannerTitle="$t('digitalPlatformPage.bannerTitle')"
      :bannerText="$t('digitalPlatformPage.bannerText')"
      :characterList="characterList"
      :imgTextList="imgTextList"
      isRightPostion
    />
  </div>
</template>

<script setup>
import serviceList from '../../components/template/serviceList.vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const bannerUrl = require('@assets/images/banner/banner-techology-platform.png');
const characterList = [
  {
    img: require('@assets/icons/ico-digital-platform_1.svg'),
    title: t('digitalPlatformPage.feature1.title'),
    text: t('digitalPlatformPage.feature1.text'),
  },
  {
    img: require('@assets/icons/ico-digital-platform_2.svg'),
    title: t('digitalPlatformPage.feature2.title'),
    text: t('digitalPlatformPage.feature2.text'),
  },
  {
    img: require('@assets/icons/ico-digital-platform_3.svg'),
    title: t('digitalPlatformPage.feature3.title'),
    text: t('digitalPlatformPage.feature3.text'),
  },
]
const imgTextList = [
  {
    img: require('@assets/images/digital_platform_1.png'),
    title: t('digitalPlatformPage.description1.title'),
    text: t('digitalPlatformPage.description1.text'),
  },
  {
    img: require('@assets/images/digital_platform_2.png'),
    title: t('digitalPlatformPage.description2.title'),
    text: t('digitalPlatformPage.description2.text'),
  },
]
</script>